export type LOAD_INCIDENTS = 'LOAD_INCIDENTS/LOAD';
export const LOAD_INCIDENTS: LOAD_INCIDENTS = 'LOAD_INCIDENTS/LOAD';

export type TICKETS_SUMMARY_LOAD = 'TICKETS_SUMMARY/LOAD';
export const TICKETS_SUMMARY_LOAD: TICKETS_SUMMARY_LOAD = 'TICKETS_SUMMARY/LOAD';

export type TICKETS_CREATE = 'TICKETS/CREATE';
export const TICKETS_CREATE: TICKETS_CREATE = 'TICKETS/CREATE';

export type TICKET_DETAILS_LOAD = 'TICKET_DETAILS/LOAD';
export const TICKET_DETAILS_LOAD: TICKET_DETAILS_LOAD = 'TICKET_DETAILS/LOAD';

export type TICKET_ACTIVITIES_LOAD = 'TICKET_ACTIVITIES/LOAD';
export const TICKET_ACTIVITIES_LOAD: TICKET_ACTIVITIES_LOAD = 'TICKET_ACTIVITIES/LOAD';

export type TICKET_ATTACHMENTS_LOAD = 'TICKET_ATTACHMENTS/LOAD';
export const TICKET_ATTACHMENTS_LOAD: TICKET_ATTACHMENTS_LOAD = 'TICKET_ATTACHMENTS/LOAD';

export type TICKET_ATTACHMENTS_DELETE = 'TICKET_ATTACHMENTS/DELETE';
export const TICKET_ATTACHMENTS_DELETE: TICKET_ATTACHMENTS_DELETE = 'TICKET_ATTACHMENTS/DELETE';

export type TICKETS_POST_COMMENT = 'TICKETS/POST_COMMENT';
export const TICKETS_POST_COMMENT: TICKETS_POST_COMMENT = 'TICKETS/POST_COMMENT';

export type TICKETS_SERVICE_LOAD = 'TICKETS_SERVICE/LOAD';
export const TICKETS_SERVICE_LOAD: TICKETS_SERVICE_LOAD = 'TICKETS_SERVICE/LOAD';

export type TICKETS_SERVICE_TYPES_LOAD = 'TICKETS_SERVICE_TYPES/LOAD';
export const TICKETS_SERVICE_TYPES_LOAD: TICKETS_SERVICE_TYPES_LOAD = 'TICKETS_SERVICE_TYPES/LOAD';

export type TICKETS_SERVICE_LOCATIONS_LOAD = 'TICKETS_SERVICE_LOCATIONS/LOAD';
export const TICKETS_SERVICE_LOCATIONS_LOAD: TICKETS_SERVICE_LOCATIONS_LOAD = 'TICKETS_SERVICE_LOCATIONS/LOAD';

export type TICKET_PATCH = 'TICKETS/PATCH';
export const TICKET_PATCH: TICKET_PATCH = 'TICKETS/PATCH';

export type ESCALATE_INCIDENT = 'ESCALATE/INCIDENT';
export const ESCALATE_INCIDENT: ESCALATE_INCIDENT = 'ESCALATE/INCIDENT';

export type CLOSE_INCIDENT_PATCH = 'CLOSE_INCIDENT_PATCH';
export const CLOSE_INCIDENT_PATCH: CLOSE_INCIDENT_PATCH = 'CLOSE_INCIDENT_PATCH';

export type TICKET_ATTACHMENTS_PATCH = 'TICKETS_ATTACHMENTS/PATCH';
export const TICKET_ATTACHMENTS_PATCH: TICKET_ATTACHMENTS_PATCH = 'TICKETS_ATTACHMENTS/PATCH';

export type TICKET_SERVICE_ID_PATCH = 'TICKET_SERVICE_ID/PATCH';
export const TICKET_SERVICE_ID_PATCH: TICKET_SERVICE_ID_PATCH = 'TICKET_SERVICE_ID/PATCH';

export type TICKET_SUMMARY_UPDATE = 'TICKET_SUMMARY/UPDATE';
export const TICKET_SUMMARY_UPDATE: TICKET_SUMMARY_UPDATE = 'TICKET_SUMMARY/UPDATE';

export type TICKET_CUSTOMER_REFERENCE_UPDATE = 'TICKET_CUSTOMER_REFERENCE/UPDATE';
export const TICKET_CUSTOMER_REFERENCE_UPDATE: TICKET_CUSTOMER_REFERENCE_UPDATE = 'TICKET_CUSTOMER_REFERENCE/UPDATE';

export type TICKET_ATTACHMENTS_LIST_UPDATE = 'TICKET_ATTACHMENTS_LIST/UPDATE';
export const TICKET_ATTACHMENTS_LIST_UPDATE: TICKET_ATTACHMENTS_LIST_UPDATE = 'TICKET_ATTACHMENTS_LIST/UPDATE';

export type TICKET_SESSION_STORAGE_UPDATE = 'TICKET_SESSION_STORAGE/UPDATE';
export const TICKET_SESSION_STORAGE_UPDATE: TICKET_SESSION_STORAGE_UPDATE = 'TICKET_SESSION_STORAGE/UPDATE';

export type TICKET_COMPANY_LOAD = 'TICKET_COMPANY/LOAD';
export const TICKET_COMPANY_LOAD: TICKET_COMPANY_LOAD = 'TICKET_COMPANY/LOAD';

export type TICKET_FILE_UPLOAD = 'TICKET_FILE_UPLOAD';
export const TICKET_FILE_UPLOAD: TICKET_FILE_UPLOAD = 'TICKET_FILE_UPLOAD';

export type TICKET_FEATURE_FLAGS = 'TICKET_FEATURE_FLAGS';
export const TICKET_FEATURE_FLAGS: TICKET_FEATURE_FLAGS = 'TICKET_FEATURE_FLAGS';

export type TICKET_CUSTOM_SERVICE_ID_UPDATE = 'TICKET_CUSTOM_SERVICE_ID_UPDATE';
export const TICKET_CUSTOM_SERVICE_ID_UPDATE: TICKET_CUSTOM_SERVICE_ID_UPDATE
    = 'TICKET_CUSTOM_SERVICE_ID_UPDATE';

export type TICKET_REQUESTED_CLOSURE_FLAG_UPDATE = 'TICKET_REQUESTED_CLOSURE_FLAG_UPDATE';
export const TICKET_REQUESTED_CLOSURE_FLAG_UPDATE: TICKET_REQUESTED_CLOSURE_FLAG_UPDATE
    = 'TICKET_REQUESTED_CLOSURE_FLAG_UPDATE';

export type TICKET_SERVICE_LOCATIONS = 'TICKET_SERVICE_LOCATIONS';
export const TICKET_SERVICE_LOCATIONS: TICKET_SERVICE_LOCATIONS = 'TICKET_SERVICE_LOCATIONS';

export type TICKET_MAJOR_INCIDENTS = 'TICKET_MAJOR_INCIDENTS';
export const TICKET_MAJOR_INCIDENTS: TICKET_MAJOR_INCIDENTS = 'TICKET_MAJOR_INCIDENTS';

export type TICKET_SELECTED_MAJOR_INCIDENT = 'TICKET_SELECTED_MAJOR_INCIDENT';
export const TICKET_SELECTED_MAJOR_INCIDENT: TICKET_SELECTED_MAJOR_INCIDENT = 'TICKET_SELECTED_MAJOR_INCIDENT';

export type UPDATE_COVID19_INCIDENT_FLAG = 'UPDATE_COVID19_INCIDENT_FLAG';
export const UPDATE_COVID19_INCIDENT_FLAG: UPDATE_COVID19_INCIDENT_FLAG = 'UPDATE_COVID19_INCIDENT_FLAG';

export type USER_MANAGEMENT_FETCH_PROFILE = 'USER_MANAGEMENT_FETCH_PROFILE';
export const USER_MANAGEMENT_FETCH_PROFILE: USER_MANAGEMENT_FETCH_PROFILE
    = 'USER_MANAGEMENT_FETCH_PROFILE';

export type INCIDENTS_FILTER_OPTIONS_LOAD = 'INCIDENTS_FILTER_OPTIONS/LOAD';
export const INCIDENTS_FILTER_OPTIONS_LOAD: INCIDENTS_FILTER_OPTIONS_LOAD = 'INCIDENTS_FILTER_OPTIONS/LOAD';

export type INCIDENTS_FILTER_LOCATIONS_LOAD = 'INCIDENTS_FILTER_LOCATIONS/LOAD';
export const INCIDENTS_FILTER_LOCATIONS_LOAD: INCIDENTS_FILTER_LOCATIONS_LOAD = 'INCIDENTS_FILTER_LOCATIONS/LOAD';

export type INCIDENTS_TENANCY_IDS_LOAD = 'INCIDENTS_TENANCY_IDS/LOAD';
export const INCIDENTS_TENANCY_IDS_LOAD: INCIDENTS_TENANCY_IDS_LOAD = 'INCIDENTS_TENANCY_IDS/LOAD';

export type MERGE_TEST_ID_LOAD = 'MERGE_TEST_ID/LOAD';
export const MERGE_TEST_ID_LOAD: MERGE_TEST_ID_LOAD = 'MERGE_TEST_ID/LOAD';

export type MERGE_TEST_RESULTS_LOAD = 'MERGE_TEST_RESULTS/LOAD';
export const MERGE_TEST_RESULTS_LOAD: MERGE_TEST_RESULTS_LOAD = 'MERGE_TEST_RESULTS/LOAD';

export type MERGE_TEST_HISTORY_LOAD = 'MERGE_TEST_HISTORY/LOAD';
export const MERGE_TEST_HISTORY_LOAD: MERGE_TEST_HISTORY_LOAD = 'MERGE_TEST_HISTORY/LOAD';

export type MERGE_TEST_VALID_SERVICE_ID_LOAD = 'MERGE_TEST_VALID_SERVICE_ID/LOAD';
export const MERGE_TEST_VALID_SERVICE_ID_LOAD: MERGE_TEST_VALID_SERVICE_ID_LOAD = 'MERGE_TEST_VALID_SERVICE_ID/LOAD'

export type DYNAMIC_FORM_LOAD = 'DYNAMIC_FORM/LOAD';
export const DYNAMIC_FORM_LOAD: DYNAMIC_FORM_LOAD = 'DYNAMIC_FORM/LOAD';

export type INT_MERGE_TEST_LOAD = 'INT_MERGE_TEST/LOAD';
export const INT_MERGE_TEST_LOAD: INT_MERGE_TEST_LOAD = 'INT_MERGE_TEST/LOAD';

export type MERGE_TEST_IP_VOICE_SERVICE_ID_LOAD = 'MERGE_TEST_IP_VOICE_SERVICE_ID/LOAD';
export const MERGE_TEST_IP_VOICE_SERVICE_ID_LOAD: MERGE_TEST_IP_VOICE_SERVICE_ID_LOAD
    = 'MERGE_TEST_IP_VOICE_SERVICE_ID/LOAD'

export type MERGE_TEST_IP_VOICE_RESULTS_LOAD = 'MERGE_TEST_IP_VOICE_RESULTS/LOAD';
export const MERGE_TEST_IP_VOICE_RESULTS_LOAD: MERGE_TEST_IP_VOICE_RESULTS_LOAD = 'MERGE_TEST_IP_VOICE_RESULTS/LOAD';

export type GUEST_SERVICE_ADDRESS_LOAD = 'GUEST_SERVICE_ADDRESS/LOAD';
export const GUEST_SERVICE_ADDRESS_LOAD: GUEST_SERVICE_ADDRESS_LOAD = 'GUEST_SERVICE_ADDRESS/LOAD';

export type GUEST_SERVICE_ADDRESS_CONTACT_LOAD = 'GUEST_SERVICE_ADDRESS_CONTACT/LOAD';
export const GUEST_SERVICE_ADDRESS_CONTACT_LOAD: GUEST_SERVICE_ADDRESS_CONTACT_LOAD = 'GUEST_SERVICE_ADDRESS_CONTACT/LOAD';

export type GUEST_SERVICE_ID_LOAD = 'GUEST_SERVICE_ID/LOAD';
export const GUEST_SERVICE_ID_LOAD: GUEST_SERVICE_ID_LOAD = 'GUEST_SERVICE_ID/LOAD';

export type GUEST_INCIDENTS_LOAD = 'GUEST_INCIDENTS/LOAD';
export const GUEST_INCIDENTS_LOAD: GUEST_INCIDENTS_LOAD = 'GUEST_INCIDENTS/LOAD';

export type GUEST_INCIDENTS_SUMMARY_LOAD = 'GUEST_INCIDENTS_SUMMARY/LOAD';
export const GUEST_INCIDENTS_SUMMARY_LOAD: GUEST_INCIDENTS_SUMMARY_LOAD = 'GUEST_INCIDENTS_SUMMARY/LOAD';

export type GUEST_INCIDENT_CREATE = 'GUEST_INCIDENT/CREATE';
export const GUEST_INCIDENT_CREATE: GUEST_INCIDENT_CREATE = 'GUEST_INCIDENT/CREATE';

export type GUEST_INCIDENT_DETAILS_LOAD = 'GUEST_INCIDENT_DETAILS/LOAD';
export const GUEST_INCIDENT_DETAILS_LOAD: GUEST_INCIDENT_DETAILS_LOAD = 'GUEST_INCIDENT_DETAILS/LOAD';

export type RAISED_FOR_LOAD = 'RAISED_FOR/LOAD';
export const RAISED_FOR_LOAD: RAISED_FOR_LOAD = 'RAISED_FOR/LOAD';

export type DOWNLOAD_SUMMARY_INT = 'DOWNLOAD_SUMMARY_INT';
export const DOWNLOAD_SUMMARY_INT: DOWNLOAD_SUMMARY_INT = 'DOWNLOAD_SUMMARY_INT';

export type INIT_DOWNLOAD_SUMMARY_INT = 'INIT_DOWNLOAD_SUMMARY_INT';
export const INIT_DOWNLOAD_SUMMARY_INT: INIT_DOWNLOAD_SUMMARY_INT = 'INIT_DOWNLOAD_SUMMARY_INT';

export type GLOBAL_LOCATION_SERVICE_IDS_LOAD = 'GLOBAL_LOCATION_SERVICE_IDS/LOAD';
export const GLOBAL_LOCATION_SERVICE_IDS_LOAD: GLOBAL_LOCATION_SERVICE_IDS_LOAD = 'GLOBAL_LOCATION_SERVICE_IDS/LOAD';

export type GLOBAL_INCIDENTS_FILTER_LOCATIONS_LOAD = 'GLOBAL_INCIDENTS_FILTER_LOCATIONS/LOAD';
export const GLOBAL_INCIDENTS_FILTER_LOCATIONS_LOAD: GLOBAL_INCIDENTS_FILTER_LOCATIONS_LOAD = 'GLOBAL_INCIDENTS_FILTER_LOCATIONS/LOAD';

export type GLOBAL_INCIDENTS_FILTER_OPTIONS_LOAD = 'GLOBAL_INCIDENTS_FILTER_OPTIONS/LOAD';
export const GLOBAL_INCIDENTS_FILTER_OPTIONS_LOAD: GLOBAL_INCIDENTS_FILTER_OPTIONS_LOAD = 'GLOBAL_INCIDENTS_FILTER_OPTIONS/LOAD';

export type GLOBAL_INCIDENT_PATCH = 'GLOBAL_INCIDENT/PATCH';
export const GLOBAL_INCIDENT_PATCH: GLOBAL_INCIDENT_PATCH = 'GLOBAL_INCIDENT/PATCH';

export type TRACK_INCIDENTS_LIST_LOAD = 'TRACK_INCIDENTS_LIST/LOAD';
export const TRACK_INCIDENTS_LIST_LOAD: TRACK_INCIDENTS_LIST_LOAD = 'TRACK_INCIDENTS_LIST/LOAD';
